<template>
    <div
        class="dap-multi-select-pull"
        :class="[{
            'is-border': !hideInput && !hideBorder,
            'isActive': isShowCollapsed,
            'not-allowed': disabled,
        }]"
        :style="{width: `${width}px`, height: calHeight}"
        v-on-clickaway="handleAway"
    >
        <div
            class="select-result"
            :class="[{
                'not-allowed': disabled,
                'hand': !disabled,
                'hide-input': !!hideInput
            }]"
            @click="handleSwitchCollapsed"
        >
            <div class="c-999 select-bar f12" v-if="resultList.length === 0">
                <div class="c-999 text-left flex-normal">
                    <slot name="prefix">
                        <div style="width: 7px;"></div>
                    </slot>
                    <div style="flex: 1">{{ placeholder }}</div>
                </div>
                <div class="right-suffix" :class="[{opened: isShowCollapsed}]">
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
            <div v-else :title="strResultNames" class="select-bar f12">
                <div
                    class="text-left flex-normal text-ellipsis"
                    :title="strResultNames">
                    <slot name="prefix">
                        <div style="width: 7px;"></div>
                    </slot>
                    <div class="text-ellipsis" style="flex: 1">{{strResultNames}}</div>
                </div>
                <div class="c-999 text-right m-r-5" style="border-radius: 2px" v-if="showPlus">
                    +{{resultList.length}}
                </div>
                <div class="right-suffix" :class="[{opened: isShowCollapsed}]">
                    <i class="el-icon-error c-999 can-change-error"
                       v-if="clearable && resultList.length > 0"  @click.stop="handleClickDelete"></i>
                    <i class="el-icon-arrow-down" :class="[{opened: isShowCollapsed}, {'can-change-arrow': clearable && resultList.length > 0}]"></i>
                </div>
            </div>
        </div>
        <transition name="el-zoom-in-top">
            <ul class="data-list" v-if="isShowCollapsed" :style="`width: ${contentWidth}px;`" :class="{'size-small': size === 'small'}">

                <li v-if="filterable && selfDataList.length > 0" class="search-bar m-b-5">
                    <el-input v-model="search_words" placeholder="请输入关键词" size="mini">
                        <i slot="suffix" class="el-icon-search"></i>
                    </el-input>
                </li>

                <li v-if="loading" class="f12 text-center">
                    <i class="el-icon-loading"></i>数据加载中
                </li>

                <li v-else-if="filteredDataList.length === 0">
                    <div class="text-center c-999 f12">暂无数据</div>
                </li>

                <li
                    class="f12 hand" :class="[this.isCheckAll ? 'active' : '']"
                    v-if="filteredDataList.length > 0 && maxCount === 0"
                    @click="handleSelectAll"
                >
                    <i class="m-r-3">
                        <DapIconSvg
                            class="f18" :class="this.isCheckAll ? 'c-blue' : ''"
                            :iconClass="this.isCheckAll ? 'duoxuanxuanzhong' : 'duoxuanweixuan'" />
                    </i>
                    全部
                </li>

                <li
                    class="f12 text-ellipsis hand" :title="item[propsMapper.label]"
                    :class="{
                        active: isActive(item),
                        disabled: (reachedMaxCount && !isActive(item)) || isDisable(item),
                    }"
                    v-for="item in filteredDataList" :key="item[propsMapper.value]"
                    @click="handleSelect(item)">
                    <i class="m-r-3">
                        <DapIconSvg class="f18"
                                    :class="reachedMaxCount && !isActive(item) && 'c-disabled'"
                                    :iconClass="isActive(item) ? 'duoxuanxuanzhong' : (reachedMaxCount || isDisable(item)) ? 'duoxuanbukexuan' : 'duoxuanweixuan'" />
                    </i>
                    <slot name="label" :item="item">
                        <div :class="{'c-disabled': reachedMaxCount}" class="flex-normal">
                            <div>{{ item[propsMapper.label] }}</div>
                        </div>
                    </slot>
                </li>

            </ul>
        </transition>

        <div class="list-arrow" v-show="isShowCollapsed" :class="{'size-small': size === 'small'}"></div>
    </div>
</template>

<script>
import {directive as onClickaway} from 'vue-clickaway';
import DapIconSvg from '../../icon-svg';
export default {
    name: 'DapMultiSelectPull',
    directives: {
        onClickaway: onClickaway,
    },
    components: {
        DapIconSvg,
    },
    props: {
        dataList: {
            type: Array,
            default: () => [],
        },
        resultList: {
            type: Array,
            default: () => []
        },
        // 对应的数据源的属性
        propsMapper: {
            type: Object,
            default: () => ({ value: 'value', label: 'label' })
        },
        disabled: {
            type: Boolean,
            default: false
        },
        width: {
            type: [Number, String],
            default: 200
        },
        contentWidth: {
            type: [Number, String],
            default: 200,
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        hideInput: {
            type: Boolean,
            default: false,
        },
        hideBorder: {
            type: Boolean,
            default: false,
        },
        filterable: {
            type: Boolean,
            default: true,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        size: {
            type: String,
            default: 'mini',
        },
        maxCount: {
            type: Number,
            default: 0,
        },
        showPlus: {
            type: Boolean,
            default: true,
        },
        remote: {
            type: Boolean,
            default: false,
        },
        loadMore: {
            type: Function,
            default: null,
        },
        disableList: {
            type: Array,
            default: () => [],
        },
    },
    provide () {
        return {
            elForm: '',
            elFormItem: '',
        };
    },

    data () {
        return {
            isShowCollapsed: false,
            search_words: '',
            selfDataList: [],
            loading: false,
        };
    },

    computed: {

        strResultNames () {
            return this.resultList.map(item => item[this.propsMapper.label]).join('、');
        },
        isCheckAll () {
            const res = this.dataListIds.filter(i => !this.resultListIds.includes(i));
            return res.length === 0;
        },
        resultListIds () {
            return this.resultList.map(i => i[this.propsMapper.value]);
        },
        dataListIds () {
            return this.selectableDataList.map(i => i[this.propsMapper.value]);
        },
        valueList () {
            return this.resultList.map(i => i[this.propsMapper.value]);
        },
        selectableDataList () {
            return this.filteredDataList.filter(i => !this.isDisable(i))
        },
        filteredDataList () {
            return this.selfDataList.filter(i => i[this.propsMapper.label].toLowerCase().includes(this.search_words.toLowerCase()));
        },
        calHeight () {
            return {
                mini: '28px',
                small: '32px',
            }[this.size];
        },
        reachedMaxCount () {
            return this.resultList.length >= this.maxCount && this.maxCount !== 0;
        }
    },

    methods: {

        handleSelect (item) {
            if (this.isDisable(item)) {
                return;
            }
            let resultList = this.resultList;
            const value = this.propsMapper.value;
            if (this.isActive(item)) {
                resultList = this.resultList.filter(i => i[value] !== item[value]);
            } else {
                if (!this.reachedMaxCount) {
                    resultList = this.selfDataList.filter(i => this.valueList.includes(i[value]) || i[value] === item[value]);
                }
            }
            this.$emit('change', resultList);
        },

        handleSelectAll () {
            if (this.isCheckAll) {
                this.$emit('change', this.resultList.filter(i => !this.dataListIds.includes(i[this.propsMapper.value])));
            } else {
                const addIds = this.dataListIds.filter(i => !this.resultListIds.includes(i));
                this.$emit('change', this.resultList.concat(this.filteredDataList.filter(i => addIds.includes(i[this.propsMapper.value]))));
            }
        },

        isActive (item) {
            return this.valueList.includes(item[this.propsMapper.value]);
        },

        isDisable (item) {
            return item.disabled || this.disableList.includes(item[this.propsMapper.value]);
        },

        handleClickDelete () {
            if (this.disabled) return;
            if (!this.hideInput) {
                if (this.$listeners.delete) {
                    this.$emit('delete');
                }
                this.$emit('change', []);
            } else {
                this.isShowCollapsed = !this.disabled && !this.isShowCollapsed;
            }
        },

        handleAway () {
            this.isShowCollapsed = false;
        },

        async handleSwitchCollapsed () {
            this.isShowCollapsed = !this.disabled && !this.isShowCollapsed;
            if (this.isShowCollapsed) {
                this.search_words = '';
                if (this.remote && !!this.loadMore) {
                    this.selfDataList = [];
                    this.loading = true;
                    const [res, total] = await this.loadMore({page: 1, pageSize: 1000});
                    this.selfDataList = res;
                    this.loading = false;
                }
            }
        },


    },

    watch: {
        dataList: {
            handler (val) {
                if (val) {
                    this.selfDataList = val;
                }
            },
            deep: true,
            immediate: true,
        }
    }

};
</script>

<style lang="scss">
.dap-multi-select-pull {
    position: relative;
    display: inline-flex;
    box-sizing: border-box;
    padding: 0 8px 0 8px;

    .can-change-error {
        display: none;
    }

    &.not-allowed {
        background-color: #f5f7fa;
    }

    &:hover {
        .can-change-error {
            display: inline-block;
        }
        .can-change-arrow {
            display: none;
        }
    }

    &.is-border {
        border: 1px solid #DCDFE6 ;
        outline: 0;
        transition: border-color 0.2s;
        border-radius: 4px;

        &:hover {
            border-color: #C0C4CC;
        }

        &.isActive {
            border-color: #4285F4;
        }
    }

    .select-result {
        position: relative;
        width: 100%;

        &.not-allowed {
            cursor: not-allowed;
            .text-ellipsis {
                color: #999;
            }
        }

        &.hide-input {
            opacity: 0;
        }

        .text-ellipsis {
            min-width: 30px;
            // max-width: 200px;
        }

        .select-bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100%;
            .text-left {
                flex: 1;
                white-space: nowrap;
            }
            .text-right {
                flex: 0 0 10px;
                white-space: nowrap;
                background-color: #F4F4F5;
                box-sizing: border-box;
                padding: 0 3px;
                color: #606266;
                line-height: 16px;
            }
            .right-suffix {
                flex: 0 0 10px;
                color: #c0c4cc;
                text-align: center;
                display: flex;
                .el-icon-arrow-down {
                    transition: all 0.3s;
                    transform-origin: 6px 6px;
                    transform: rotate(0);
                }
                &.opened {
                    .el-icon-arrow-down {
                        transform: rotate(-180deg);
                    }
                }
            }
        }
    }

    .data-list {
        position: absolute;
        z-index: 999;
        top: 29px;
        left: -1px;
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
        background-color: #fff;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin: 5px 0;
        box-sizing: border-box;
        padding: 6px 0;

        &.size-small {
            top: 33px;
        }

        li {
            box-sizing: border-box;
            width: 100%;
            height: 30px;
            line-height: 30px;
            padding: 0 10px 0 15px;
            text-align: left;
            display: flex;
            align-items: center;
            i {
                display: inline-flex;
                align-items: center;
            }

            .el-input {
                input {
                    font-size: 12px;
                    border-radius: 0;
                    border: none;
                    border-bottom: 1px solid #dcdfe6;
                    padding-left: 0;
                }
            }

            &:hover:not(.search-bar) {
                background-color: #f5f7fa;
                color: #4285F4;

                i.fa {
                    color: #4285F4;
                }
            }

            &.active {
                color: #4285F4;
                i {
                    color: #4285F4;
                }
            }
            &.disabled:not(.active) {
                color: #999999;
                cursor: not-allowed;
            }
        }
    }

    .list-arrow, .list-arrow::after {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        border-width: 6px;
    }

    .list-arrow {
        filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .03));
        top: 29px;
        left: 36px;
        margin-right: 3px;
        border-top-width: 0;
        border-bottom-color: #ebeef5;
        z-index: 999;

        &.size-small {
            top: 33px;
        }

        &::after {
            content: " ";
            top: 1px;
            margin-left: -6px;
            border-top-width: 0;
            border-bottom-color: #fff;
        }
    }
}

</style>
